<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Claire is an Australian author who has been writing picture story and children’s books since the age of 6. This is her first young adult novel. She sees herself as an observer of life and her philosophy is to create stories that entertain, inspire, educate or challenge the reader, whilst tackling subjects that children and adults alike can relate to such as food allergies, disability, organ transplant, mental health, Australian bushfires and floods. She can often be found writing at her desk with a chai latte and a cat on her lap.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?955f2272